import {createReactQueryHooks} from '@trpc/react';
import {AppRouter} from '../server/router/app';

export const {
  useQuery: useTtxQuery,
  useMutation: useTtxMutation,
  createClient: createTrpcClient,
  Provider: TrpcProvider,
} = createReactQueryHooks<AppRouter>();
